import React from "react";
import RouterSetup from "../Routes/RouterSetup";
function App() {
	return (
		<div className="App">
			<RouterSetup></RouterSetup>
		</div>
	);
}

export default App;
